class TpVideoShowcase extends HTMLElement {
  connectedCallback() {
    this.videoEl = this.querySelector('video');
    this.soundButton = this.querySelector('[data-sound-toggle]');

    if (!this.videoEl) {
      if (this.soundButton) this.soundButton.hidden = true;
      return;
    }

    this.videoEl.muted = true;
    this.videoEl.playsInline = true;

    this.handleSoundToggle = this.handleSoundToggle.bind(this);

    if (this.soundButton) {
      this.soundButton.addEventListener('click', this.handleSoundToggle);
      this.syncSoundButton();
    }

    this.watchVisibility();
  }

  disconnectedCallback() {
    if (this.soundButton) {
      this.soundButton.removeEventListener('click', this.handleSoundToggle);
    }
    if (this.observer) this.observer.disconnect();
  }

  handleSoundToggle() {
    this.videoEl.muted = !this.videoEl.muted;

    if (this.videoEl.paused) this.playVideo();

    this.syncSoundButton();
  }

  syncSoundButton() {
    const isMuted = this.videoEl.muted;

    this.soundButton.dataset.muted = String(isMuted);
    this.soundButton.setAttribute(
      'aria-label',
      isMuted ? this.soundButton.dataset.labelUnmute : this.soundButton.dataset.labelMute
    );
  }

  playVideo() {
    const played = this.videoEl.play();

    if (played && typeof played.catch === 'function') played.catch(() => {});
  }

  watchVisibility() {
    if (!('IntersectionObserver' in window)) {
      this.playVideo();
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.playVideo();
          } else if (!this.videoEl.paused) {
            this.videoEl.pause();
          }
        });
      },
      { threshold: 0.2 }
    );

    this.observer.observe(this.videoEl);
  }
}

if (!customElements.get('tp-video-showcase')) {
  customElements.define('tp-video-showcase', TpVideoShowcase);
}
